<script setup lang="ts">
import { computed } from 'vue'
import type { ImagesType } from 'Modules/types/generic/image/ImagesType'
import { useRoute, useRouter } from 'vue-router'
import { JeteyeRoutes } from 'Modules/RouterSetup'

const router = useRouter()
const route = useRoute()

interface PropTypes {
  images: ImagesType
}

const props = defineProps<PropTypes>()
const handleClose = ()=>{
    const uuid = props.images.incomplete[0].imageUuid
    if (uuid && route.query.inspectionInstance)
    router.push({
      name: JeteyeRoutes.ImageReview,
      query: { inspectionInstance: route.query.inspectionInstance, inspectionImage: [uuid] },
    })
    else console.error("Image and Inspection Instance UUID's are not defined and are required to build review page url.")
}

const showAlert = computed(() => {
  return props.images?.incomplete?.length >=1
})
</script>

<template>
  <el-alert
        v-if="showAlert"
        class="review-alert is-big"
        type="warning"
        show-icon
        close-text="Review" 
        effect="dark"
        @close="handleClose"
      >
      <template #title>
        <span>You have {{ props.images?.incomplete?.length }} image(s) that need reviewed.</span>
      </template>
    </el-alert>
</template>
<style>
.review-alert.el-alert{
  .el-alert__title{
    font-size: 18px;
    padding: 1.5rem;
  }

  .el-alert__close-btn.is-customed {
    font-size: 18px;
    padding: 1rem;
    margin: 0.5rem;
    background-color: rgba(255,255,255,0.125);
    border-radius: 10px;
  }

  .el-alert__icon{
    font-size: 28px;
    width: 28px;
  }
}
</style>
